module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/binding_sample/image10-1dd972e48774e006cf1a27dad8600549.png";